import {
	DEFAULT_AGENT_NAMED_ID,
	DEFAULT_AGENT_UUID,
} from '@atlassian/conversation-assistant-utils/default-agent';

/**
 * Strips whitespace and known default-agent sentinels from a raw agent id or named-id field.
 * Returns undefined when the value is empty, whitespace-only, or matches a default-agent
 * sentinel, indicating a default Rovo turn rather than a specialist agent identity.
 */
export const normalizeAgentIdentityValue = (value?: string | null): string | undefined => {
	const trimmedValue = value?.trim();
	if (!trimmedValue) {
		return undefined;
	}

	return trimmedValue === DEFAULT_AGENT_NAMED_ID || trimmedValue === DEFAULT_AGENT_UUID
		? undefined
		: trimmedValue;
};
